module.exports = __webpack_public_path__ + "img/122.47a59a81.jpg";